
  (() => {
    const normalize = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const solarmoduleQuantity = (value) => {
      const text = normalize(value);
      if (/\b(ohne|kein|keine|keinen)\b/.test(text) || text === '0') return 0;
      const patterns = [/(?:x|×)\s*(\d{1,2})/, /(\d{1,2})\s*(?:x|×)/, /(\d{1,2})\s*(?:solar)?module?\b/, /(\d{1,2})\s*panels?\b/, /(?:anzahl|menge)\D{0,6}(\d{1,2})/];
      for (const pattern of patterns) {
        const match = text.match(pattern);
        if (match) return Number(match[1]);
      }
      return null;
    };
    const shippingDelivery = window.MPSmartShippingDelivery;
    const resolveDelivery = (variant, country, classifications) => {
      if (!shippingDelivery) return { status: 'unavailable', mode: '' };
      return shippingDelivery.resolve({
        variant,
        classification: shippingDelivery.classificationFor(variant, classifications),
        country,
      });
    };
    const deliveryText = (variant, country, classifications) => {
      if (!shippingDelivery) return 'Lieferzeit wird im Checkout berechnet';
      return shippingDelivery.text(resolveDelivery(variant, country, classifications), {
        available: Boolean(variant.available),
      });
    };
    const taxNoteText = (card) => {
      const taxSelector = document.querySelector('#mp-tax-selector');
      if (!taxSelector) return 'Preis gemäß aktueller Shop-Einstellung';
      const country = String(taxSelector.dataset.country || 'DE').toUpperCase();
      const role = taxSelector.querySelector('[data-mp-tax-role][aria-pressed="true"]')?.dataset.mpTaxRole || 'private';
      const mode = String(card.dataset.mpTaxMode || '');
      if (mode === 'de0_twin') {
        if (country === 'DE') return role === 'business' ? 'Bruttopreis inkl. 19 % MwSt.' : 'Preis mit 0 % MwSt.';
        return role === 'business'
          ? 'Voraussichtlicher Nettopreis · USt-IdNr. wird im Checkout geprüft'
          : `Voraussichtlicher Bruttopreis inkl. MwSt. in ${country} · endgültig im Checkout`;
      }
      if (mode === 'gross_inclusive_single') {
        if (country === 'DE') return 'Shopify-Preis inkl. 19 % MwSt.';
        return role === 'business'
          ? 'Voraussichtlicher Nettopreis · USt-IdNr. wird im Checkout geprüft'
          : `Shopify-Preis inkl. MwSt. in ${country} · endgültig im Checkout`;
      }
      return 'Preis gemäß aktueller Shop-Einstellung · Steuerberechnung im Checkout';
    };
    const updateTaxNote = (card) => {
      const note = card.querySelector('[data-card-price-note]');
      if (note) note.textContent = taxNoteText(card);
    };
    const ensureTaxVariant = async (card, variant) => {
      const mode = String(variant?.taxMode || '');
      if (!mode) return true;
      if (mode !== 'de0_twin' && mode !== 'gross_inclusive_single') return false;
      const ensureVariant = window.MiniPowerTax?.ensureVariant;
      if (typeof ensureVariant !== 'function') return false;
      try {
        return await ensureVariant(card, variant.id) === true;
      } catch (error) {
        return false;
      }
    };
    const connectTaxNotes = (root, records) => {
      const refresh = () => records.forEach((record) => { if (record.card) updateTaxNote(record.card); });
      refresh();
      const taxSelector = document.querySelector('#mp-tax-selector');
      if (!taxSelector) return;
      const observer = new MutationObserver(refresh);
      observer.observe(taxSelector, { attributes: true, subtree: true, attributeFilter: ['aria-pressed', 'data-country'] });
      root._mpTaxNoteObserver = observer;
    };
    const hydrateDesktopHero = (root) => {
      const template = root.querySelector('template[data-desktop-hero]');
      if (!template) return;
      const media = window.matchMedia('(min-width: 761px)');
      const sync = () => {
        const instance = root.querySelector('[data-desktop-hero-instance]');
        if (!media.matches) {
          instance?.remove();
          return;
        }
        if (instance) return;
        const fragment = template.content.cloneNode(true);
        const element = fragment.firstElementChild;
        if (!element) return;
        element.dataset.desktopHeroInstance = '';
        template.after(fragment);
      };
      sync();
      media.addEventListener('change', sync);
      root._mpHeroMedia = media;
      root._mpHeroSync = sync;
    };
    const init = (root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      hydrateDesktopHero(root);
      const grid = root.querySelector('[data-product-grid]');
      const deferredCardTemplates = Array.from(grid.querySelectorAll(':scope > template[data-card-template]'));
      const liveCards = Array.from(grid.querySelectorAll(':scope > [data-card]'));
      const createRecord = (source, card = null, template = null, catalogPage = 0) => ({ dataset: { ...source.dataset }, card, template, initialized: false, catalogPage });
      const records = [
        ...liveCards.map((card) => createRecord(card, card)),
        ...deferredCardTemplates.map((template) => createRecord(template, null, template))
      ];
      const recordByHandle = new Map(records.map((record) => [record.dataset.handle, record]));
      let secondaryMediaObserver = null;
      let secondaryProximityEnabled = false;
      const instantiateSecondaryMedia = (card) => {
        const template = card?.querySelector('template[data-card-secondary-image]');
        const image = template?.content.querySelector('img')?.cloneNode(true);
        if (!template || !image) return;
        template.replaceWith(image);
        card.querySelector('.mp-uc-card-images')?.classList.add('has-secondary');
        card.dataset.secondaryMediaReady = 'true';
        secondaryMediaObserver?.unobserve(card);
      };
      const observeSecondaryMedia = (card) => {
        if (!secondaryProximityEnabled || !card?.isConnected || card.hidden || !card.querySelector('template[data-card-secondary-image]')) return;
        if (secondaryMediaObserver) {
          secondaryMediaObserver.observe(card);
          return;
        }
        const rect = card.getBoundingClientRect();
        if (rect.top < window.innerHeight + 320 && rect.bottom > -320) instantiateSecondaryMedia(card);
      };
      const scanSecondaryMedia = () => records.forEach((record) => observeSecondaryMedia(record.card));
      const enableSecondaryProximity = () => {
        if (secondaryProximityEnabled) return;
        secondaryProximityEnabled = true;
        if ('IntersectionObserver' in window) {
          secondaryMediaObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) instantiateSecondaryMedia(entry.target);
            });
          }, { rootMargin: '320px 0px', threshold: 0.01 });
          root._mpSecondaryMediaObserver = secondaryMediaObserver;
        } else {
          root._mpSecondaryScrollScan = scanSecondaryMedia;
          window.addEventListener('scroll', scanSecondaryMedia, { passive: true });
        }
        scanSecondaryMedia();
      };
      const instantiateSecondaryFromIntent = (event) => {
        const card = event.target.closest?.('[data-card]');
        if (card && root.contains(card)) instantiateSecondaryMedia(card);
      };
      const enableSecondaryFromKey = (event) => {
        if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key)) enableSecondaryProximity();
      };
      root.addEventListener('pointerover', instantiateSecondaryFromIntent);
      root.addEventListener('pointerdown', instantiateSecondaryFromIntent);
      root.addEventListener('focusin', instantiateSecondaryFromIntent);
      root.addEventListener('wheel', enableSecondaryProximity, { once: true, passive: true });
      root.addEventListener('touchmove', enableSecondaryProximity, { once: true, passive: true });
      root.addEventListener('keydown', enableSecondaryFromKey);
      root._mpSecondaryIntent = instantiateSecondaryFromIntent;
      root._mpSecondaryEnable = enableSecondaryProximity;
      root._mpSecondaryKey = enableSecondaryFromKey;
      const search = root.querySelector('[data-search]');
      const searchSubmit = root.querySelector('[data-search-submit]');
      const vendorSelect = root.querySelector('[data-vendor]');
      const typeSelect = root.querySelector('[data-product-type]');
      const loadMore = root.querySelector('[data-load-more]');
      const filters = root.querySelector('[data-filters]');
      const backdrop = root.querySelector('[data-filter-backdrop]');
      const activeRow = root.querySelector('[data-active-filters]');
      const catalogStatus = root.querySelector('[data-catalog-status]');
      const nativePagination = root.querySelector('[data-native-pagination]');
      const totalPages = Math.max(1, Number(root.dataset.totalPages || 1));
      const currentPage = Math.max(1, Number(root.dataset.currentPage || 1));
      const totalProducts = Math.max(records.length, Number(root.dataset.totalProducts || records.length));
      const productsPerPage = Math.max(1, Number(root.dataset.productsPerPage || records.length || 1));
      const expectedTotalPages = Math.max(1, Math.ceil(totalProducts / productsPerPage));
      const sectionId = root.dataset.sectionId;
      const catalogView = root.dataset.view || 'mp-universal';
      const collectionUrl = root.dataset.collectionUrl || window.location.pathname;
      records.forEach((record) => { record.catalogPage = currentPage; });
      const state = {search:'',status:'all',price:'all',category:'all',vendor:'all',productType:'all',visible:Number(root.dataset.initialProducts || 12),selected:[]};
      const initializeCard = (record) => {
        if (!record.card || record.initialized) return record.card;
        const card = record.card;
        const staticPanelSelector = card.querySelector('[data-static-panel-selector]');
        const staticPanelValue = staticPanelSelector?.querySelector('[data-panel-static-value]');
        if (staticPanelSelector && staticPanelValue) {
          const quantity = solarmoduleQuantity(staticPanelValue.dataset.panelStaticValue);
          const showStaticPanel = Number.isInteger(quantity) && quantity > 0;
          staticPanelSelector.hidden = !showStaticPanel;
          if (showStaticPanel) staticPanelValue.textContent = quantity === 1 ? '1 Modul' : `${quantity} Module`;
        }
        const variantData = card.querySelector('[data-variant-data]');
        const selector = card.querySelector('[data-panel-selector]');
        if (variantData) {
          try {
          const config = JSON.parse(variantData.textContent);
          const hasDynamicSelector = Boolean(selector);
          const panelIndex = config.panelOptionIndex == null ? -1 : Number(config.panelOptionIndex);
          const variants = Array.isArray(config.variants) ? config.variants : [];
          const classifications = config.classifications && typeof config.classifications === 'object' ? config.classifications : {};
          const deliveryCountry = String(root.dataset.deliveryCountry || 'DE').toUpperCase();
          const initialVariant = variants.find((variant) => String(variant.id) === String(config.initialVariantId)) || variants[0];
          const initialOptions = initialVariant ? [...initialVariant.options] : [];
          const buttons = selector ? [...selector.querySelectorAll('[data-panel-value]')] : [];
          const renderVariant = (variant) => {
            if (!variant) return;
            const selectedValue = panelIndex >= 0 ? (variant.options[panelIndex] || '') : '';
            const price = card.querySelector('[data-card-price-main]');
            const compare = card.querySelector('[data-card-price-compare]');
            const availability = card.querySelector('[data-card-availability]');
            const availabilityText = availability?.querySelector('b');
            const mediaAvailability = card.querySelector('[data-card-media-availability]');
            const deliveryWrap = card.querySelector('[data-card-delivery]');
            const delivery = card.querySelector('[data-card-delivery-text]');
            const taxPrice = card.querySelector('[data-product-price]');
            const saleBadge = card.querySelector('[data-card-sale]');
            const hasCompare = Number(variant.compareAtPrice) > Number(variant.price);
            const deliveryResult = resolveDelivery(variant, deliveryCountry, classifications);
            const availabilityLabel = shippingDelivery
              ? shippingDelivery.availabilityText(deliveryResult, { available: Boolean(variant.available) })
              : (variant.available ? 'Verfügbar' : 'Derzeit nicht verfügbar');
            const deliveryNeedsAttention = deliveryResult.status !== 'ok'
              || deliveryResult.mode === 'preorder'
              || (!variant.available && deliveryResult.mode !== 'preorder');
            if (hasDynamicSelector && price) price.textContent = variant.priceText;
            if (hasDynamicSelector && compare) {
              compare.hidden = !hasCompare;
              compare.textContent = hasCompare ? variant.compareAtText : '';
            }
            if (availability) availability.classList.toggle('is-request', deliveryNeedsAttention);
            if (availabilityText) availabilityText.textContent = availabilityLabel;
            if (mediaAvailability) {
              mediaAvailability.textContent = availabilityLabel;
              mediaAvailability.classList.toggle('is-preorder', deliveryResult.mode === 'preorder');
              mediaAvailability.classList.toggle('is-sold-out', deliveryResult.mode !== 'preorder' && !variant.available);
              mediaAvailability.setAttribute('aria-label', `Produktdetails öffnen: ${availabilityLabel}`);
            }
            if (delivery) delivery.textContent = deliveryText(variant, deliveryCountry, classifications);
            if (deliveryWrap) deliveryWrap.classList.toggle('is-request', deliveryNeedsAttention);
            const variantUrl = `${card.dataset.url}?variant=${encodeURIComponent(variant.id)}`;
            card.querySelectorAll('[data-card-variant-link]').forEach((link) => { link.href = variantUrl; });
            const variantDataset = {
              price: String(variant.price),
              available: String(Boolean(variant.available)),
              sale: String(hasCompare),
              mpTaxVariantId: String(variant.id),
              mpTaxMode: String(variant.taxMode || '')
            };
            if (hasDynamicSelector) {
              Object.assign(record.dataset, variantDataset);
              Object.assign(card.dataset, variantDataset);
              if (taxPrice) taxPrice.dataset.mpTaxDefaultVariantId = String(variant.id);
              updateTaxNote(card);
              if (saleBadge) saleBadge.hidden = !hasCompare;
              buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.panelValue === selectedValue)));
              if (record.initialized) {
                document.dispatchEvent(new CustomEvent('mp:tax-content-ready', { detail: { root: card } }));
              }
            }
          };
          const selectVariant = (panelValue) => {
            const hasPanelValue = (variant) => variant.options[panelIndex] === panelValue;
            const keepsInitialOptions = (variant) => variant.options.every((value, index) => index === panelIndex || value === initialOptions[index]);
            return variants.find((variant) => variant.available && hasPanelValue(variant) && keepsInitialOptions(variant))
              || variants.find((variant) => hasPanelValue(variant) && keepsInitialOptions(variant))
              || variants.find((variant) => variant.available && hasPanelValue(variant))
              || variants.find(hasPanelValue);
          };
          buttons.forEach((button) => {
            const quantity = solarmoduleQuantity(button.dataset.panelValue);
            if (quantity !== null) button.textContent = quantity === 1 ? '1 Modul' : `${quantity} Module`;
          });
          if (hasDynamicSelector) card._mpPanelSelector = { renderVariant, selectVariant };
          renderVariant(initialVariant);
          } catch (error) {
            if (selector) selector.hidden = true;
          }
        }
        const compareButton = card.querySelector('[data-compare]');
        if (compareButton) {
          const selected = state.selected.includes(record.dataset.handle);
          compareButton.classList.toggle('is-selected', selected);
          compareButton.textContent = selected ? '✓ Ausgewählt' : '+ Vergleichen';
        }
        record.initialized = true;
        updateTaxNote(card);
        document.dispatchEvent(new CustomEvent('mp:tax-content-ready', { detail: { root: card } }));
        return card;
      };
      const ensureCard = (record) => {
        if (!record.card) {
          const source = record.template?.content.querySelector('[data-card]');
          if (!source) return null;
          record.card = source.cloneNode(true);
          record.template.remove();
          record.template = null;
        }
        return initializeCard(record);
      };
      records.filter((record) => record.card).forEach(initializeCard);
      connectTaxNotes(root, records);
      const groups = (key) => records.reduce((map, record) => map.set(record.dataset[key], (map.get(record.dataset[key]) || 0) + 1), new Map());
      const setOptions = (select, map, allLabel, selectedValue) => {
        const allOption = document.createElement('option');
        allOption.value = 'all';
        allOption.textContent = allLabel;
        const options = [...map.entries()].filter(([value]) => value).sort((a,b) => b[1] - a[1]).map(([value,count]) => {
          const option=document.createElement('option');
          option.value=value;
          option.textContent=`${value} (${count})`;
          return option;
        });
        select.replaceChildren(allOption, ...options);
        select.value = [...select.options].some((option) => option.value === selectedValue) ? selectedValue : 'all';
      };
      const refreshFacetOptions = () => {
        setOptions(vendorSelect, groups('vendor'), 'Alle Marken', state.vendor);
        setOptions(typeSelect, groups('productType'), 'Alle Produkttypen', state.productType);
        state.vendor = vendorSelect.value;
        state.productType = typeSelect.value;
        [vendorSelect, typeSelect].forEach((select) => {
          select.disabled = false;
          select.removeAttribute('aria-busy');
        });
      };
      const deferredMaterialHtml = new Map();
      const catalogAbortControllers = new Set();
      root._mpCatalogAbortControllers = catalogAbortControllers;
      const pageUrl = (page) => {
        const url = new URL(collectionUrl, window.location.origin);
        const current = new URL(window.location.href);
        current.searchParams.forEach((value, key) => {
          if (!['page', 'section_id', 'sections', '_'].includes(key)) url.searchParams.append(key, value);
        });
        url.searchParams.set('view', catalogView);
        url.searchParams.set('page', String(page));
        url.searchParams.set('section_id', sectionId);
        return url;
      };
      const fetchCatalogPage = async (page) => {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 20000);
        catalogAbortControllers.add(controller);
        let response;
        try {
          response = await fetch(pageUrl(page), {
            cache: 'no-store',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            credentials: 'same-origin',
            signal: controller.signal,
          });
        } catch (error) {
          if (error?.name === 'AbortError') throw new Error(`Katalogseite ${page}: Zeitüberschreitung`);
          throw error;
        } finally {
          window.clearTimeout(timeout);
          catalogAbortControllers.delete(controller);
        }
        if (!response.ok) throw new Error(`Katalogseite ${page}: HTTP ${response.status}`);
        const documentPage = new DOMParser().parseFromString(await response.text(), 'text/html');
        const remoteRoot = documentPage.querySelector('[data-mp-universal-collection]');
        const remoteGrid = remoteRoot?.querySelector('[data-product-grid]');
        const remoteView = remoteRoot?.dataset.view || '';
        const remoteSectionId = remoteRoot?.dataset.sectionId || '';
        if (!remoteRoot || !remoteGrid) throw new Error(`Katalogseite ${page}: Abschnitt fehlt`);
        const remotePage = Number(remoteRoot.dataset.currentPage || 0);
        const remotePages = Number(remoteRoot.dataset.totalPages || 0);
        const remoteTotal = Number(remoteRoot.dataset.totalProducts || -1);
        const remoteProductsPerPage = Number(remoteRoot.dataset.productsPerPage || 0);
        if (remoteView !== catalogView) throw new Error(`Katalogseite ${page}: Ansicht ${remoteView || '?'} statt ${catalogView}`);
        if (remoteSectionId !== sectionId) throw new Error(`Katalogseite ${page}: Abschnitt ${remoteSectionId || '?'} statt ${sectionId}`);
        if (remotePage !== page) throw new Error(`Katalogseite ${page}: Server lieferte Seite ${remotePage || '?'}`);
        if (remotePages !== totalPages || remoteTotal !== totalProducts || remoteProductsPerPage !== productsPerPage) {
          throw new Error(`Katalogseite ${page}: Katalogumfang hat sich geändert`);
        }
        const cards = Array.from(remoteGrid.querySelectorAll(':scope > [data-card]'), (card) => {
          const clone = card.cloneNode(true);
          clone.querySelectorAll('img').forEach((image) => {
            image.setAttribute('loading', 'lazy');
            image.removeAttribute('fetchpriority');
          });
          return clone;
        });
        const templates = Array.from(remoteGrid.querySelectorAll(':scope > template[data-card-template]'), (template) => template.cloneNode(true));
        const sources = [...cards, ...templates];
        const handles = sources.map((source) => source.dataset.handle).filter(Boolean);
        const expectedItems = page < totalPages
          ? productsPerPage
          : Math.max(0, totalProducts - (productsPerPage * (totalPages - 1)));
        if (sources.length !== expectedItems) {
          throw new Error(`Katalogseite ${page}: ${sources.length} statt ${expectedItems} Produkte`);
        }
        if (handles.length !== sources.length || new Set(handles).size !== handles.length) {
          throw new Error(`Katalogseite ${page}: fehlende oder doppelte Produktkennung`);
        }
        return {
          page,
          cards,
          templates,
          materialTemplates: Array.from(remoteRoot.querySelectorAll('template[data-material-template]'), (template) => [template.dataset.materialTemplate, template.innerHTML]),
        };
      };
      const ingestPage = (pageData) => {
        const incoming = [...pageData.cards, ...pageData.templates];
        const duplicate = incoming.find((source) => recordByHandle.has(source.dataset.handle));
        if (duplicate) throw new Error(`Katalogseite ${pageData.page}: Produkt ${duplicate.dataset.handle} wurde doppelt geliefert`);
        pageData.cards.forEach((card) => {
          const record = createRecord(card, card, null, pageData.page);
          records.push(record);
          recordByHandle.set(record.dataset.handle, record);
        });
        pageData.templates.forEach((template) => {
          const record = createRecord(template, null, template, pageData.page);
          records.push(record);
          recordByHandle.set(record.dataset.handle, record);
        });
        pageData.materialTemplates.forEach(([id, html]) => {
          if (!id || !html || deferredMaterialHtml.has(id)) return;
          deferredMaterialHtml.set(id, html);
        });
      };
      const setCatalogScope = (prefix, label) => {
        root.querySelectorAll('[data-catalog-scope-prefix]').forEach((node) => { node.textContent = prefix; });
        root.querySelectorAll('[data-catalog-scope-label]').forEach((node) => { node.textContent = label; });
      };
      const updateGlobalCounts = () => {
        const vendors = new Set(records.map((record) => record.dataset.vendor).filter(Boolean));
        const available = records.filter((record) => record.dataset.available === 'true').length;
        const sale = records.filter((record) => record.dataset.sale === 'true').length;
        root.querySelectorAll('[data-global-product-count]').forEach((node) => { node.textContent = totalProducts; });
        root.querySelectorAll('[data-global-vendor-count]').forEach((node) => { node.textContent = vendors.size; });
        root.querySelectorAll('[data-global-available-count]').forEach((node) => { node.textContent = available; });
        root.querySelectorAll('[data-global-sale-count]').forEach((node) => { node.textContent = sale; });
        setCatalogScope('Produkte im', 'Sortiment');
      };
      const loadedPages = new Set([currentPage]);
      const pagePromises = new Map();
      let catalogPromise = null;
      let catalogFailure = null;
      const expectedCurrentItems = currentPage < totalPages
        ? productsPerPage
        : Math.max(0, totalProducts - (productsPerPage * (totalPages - 1)));
      const paginationShapeValid = totalPages === expectedTotalPages
        && currentPage <= totalPages
        && records.length === expectedCurrentItems
        && recordByHandle.size === records.length;
      let catalogReady = paginationShapeValid && totalPages === 1 && records.length === totalProducts;
      root.dataset.catalogState = catalogReady ? 'complete' : 'loading';
      const setCatalogStatus = (message, visible = false, announce = false) => {
        if (!catalogStatus) return;
        catalogStatus.setAttribute('aria-live', announce ? 'polite' : 'off');
        catalogStatus.textContent = message;
        catalogStatus.classList.toggle('is-visible', visible);
      };
      const sortRecords = () => records.sort((a,b) => Number(a.dataset.index || 0) - Number(b.dataset.index || 0));
      const finalizeCatalog = () => {
        if (!paginationShapeValid || loadedPages.size !== totalPages) return false;
        if (recordByHandle.size !== totalProducts || records.length !== totalProducts) {
          throw new Error(`Gesamtkatalog: ${recordByHandle.size} eindeutige statt ${totalProducts} erwartete Produkte`);
        }
        sortRecords();
        catalogReady = true;
        catalogFailure = null;
        root.dataset.catalogReady = 'true';
        root.dataset.catalogState = 'complete';
        state.visible = totalProducts;
        refreshFacetOptions();
        renderCategoryCounts();
        updateGlobalCounts();
        if (nativePagination) nativePagination.hidden = true;
        loadMore.hidden = true;
        setCatalogStatus(`Alle ${totalProducts} Produkte werden durchsucht.`);
        return true;
      };
      const showCatalogFailure = (error) => {
        catalogReady = false;
        catalogFailure = error;
        root.dataset.catalogReady = 'false';
        root.dataset.catalogState = 'incomplete';
        if (nativePagination) nativePagination.hidden = false;
        loadMore.hidden = true;
        [vendorSelect, typeSelect].forEach((select) => {
          select.disabled = true;
          select.setAttribute('aria-busy', 'false');
        });
        setCatalogScope('Produkte auf dieser Seite', '(unvollständig)');
        setCatalogStatus('Der Gesamtkatalog konnte nicht vollständig geladen werden. Ergebnisse aus lokalen Filtern sind unvollständig; die Seitennavigation bleibt verfügbar.', true, true);
        console.error('[Mini Power Katalog] Gesamtkatalog konnte nicht vollständig bestätigt werden.', error);
      };
      const fetchAndIngestPage = async (page) => {
        if (loadedPages.has(page)) return true;
        let pagePromise = pagePromises.get(page);
        if (!pagePromise) {
          pagePromise = fetchCatalogPage(page);
          pagePromises.set(page, pagePromise);
        }
        let pageData;
        try {
          pageData = await pagePromise;
        } finally {
          pagePromises.delete(page);
        }
        if (!loadedPages.has(page)) {
          ingestPage(pageData);
          loadedPages.add(page);
          sortRecords();
        }
        return true;
      };
      const nextCatalogPage = () => {
        for (let page = 1; page <= totalPages; page += 1) {
          if (!loadedPages.has(page)) return page;
        }
        return null;
      };
      if (catalogStatus) catalogStatus.textContent = catalogReady
        ? `Alle ${totalProducts} Produkte werden durchsucht.`
        : 'Gesamtkatalog wird nach dem ersten Seitenaufbau geladen.';
      const ensureFullCatalog = () => {
        if (catalogReady) return Promise.resolve(true);
        if (catalogPromise) return catalogPromise;
        if (!paginationShapeValid) {
          const error = new Error(`Gesamtkatalog: Seiteneinteilung ${totalPages}/${expectedTotalPages} oder Startseite ist unvollständig`);
          showCatalogFailure(error);
          return Promise.resolve(false);
        }
        root.setAttribute('aria-busy', 'true');
        root.dataset.catalogState = 'loading';
        setCatalogScope('Produkte werden', 'geladen');
        setCatalogStatus('Gesamtkatalog wird geladen …');
        const pages = Array.from({length: totalPages}, (_, index) => index + 1).filter((page) => !loadedPages.has(page));
        catalogPromise = (async () => {
          const failures = [];
          const fetchedPages = [];
          let cursor = 0;
          const worker = async () => {
            while (cursor < pages.length) {
              const page = pages[cursor++];
              try {
                fetchedPages.push(await fetchCatalogPage(page));
              } catch (error) {
                failures.push({ page, error });
              }
            }
          };
          await Promise.all(Array.from({length: Math.min(2, pages.length)}, worker));
          if (failures.length) {
            const detail = failures.map(({ page, error }) => `Seite ${page}: ${error.message}`).join('; ');
            throw new Error(detail);
          }
          const allHandles = new Set(recordByHandle.keys());
          fetchedPages.forEach((pageData) => {
            [...pageData.cards, ...pageData.templates].forEach((source) => {
              const handle = source.dataset.handle;
              if (!handle || allHandles.has(handle)) throw new Error(`Katalogseite ${pageData.page}: Produkt ${handle || '?'} wurde doppelt geliefert`);
              allHandles.add(handle);
            });
          });
          fetchedPages.sort((a, b) => a.page - b.page).forEach((pageData) => {
            ingestPage(pageData);
            loadedPages.add(pageData.page);
          });
          return finalizeCatalog();
        })().catch((error) => {
          if (!root.isConnected) return false;
          showCatalogFailure(error);
          return false;
        }).finally(() => {
          catalogPromise = null;
          root.removeAttribute('aria-busy');
        });
        return catalogPromise;
      };
      const ensureNextCatalogPage = async () => {
        if (catalogReady) return true;
        if (!paginationShapeValid) return ensureFullCatalog();
        const page = nextCatalogPage();
        if (!page) {
          try { return finalizeCatalog(); }
          catch (error) { showCatalogFailure(error); return false; }
        }
        root.setAttribute('aria-busy', 'true');
        setCatalogStatus(`Weitere Produkte werden geladen (Seite ${page} von ${totalPages}) …`);
        try {
          await fetchAndIngestPage(page);
          if (loadedPages.size === totalPages) return finalizeCatalog();
          setCatalogStatus(`${records.length} von ${totalProducts} Produkten sind geladen.`);
          return true;
        } catch (error) {
          showCatalogFailure(error);
          return false;
        } finally {
          root.removeAttribute('aria-busy');
        }
      };
      const priceMatch = (price) => state.price === 'all' || (state.price === 'under-100' ? price < 10000 : state.price === '100-500' ? price >= 10000 && price < 50000 : state.price === '500-1000' ? price >= 50000 && price < 100000 : price >= 100000);
      const categoryMatch = (record, terms = state.category) => {
        if (!terms || terms === 'all') return true;
        const haystack = normalize(record.dataset.search);
        return String(terms).split('|').map(normalize).filter(Boolean).some((term) => haystack.includes(term));
      };
      const renderCategoryCounts = () => root.querySelectorAll('[data-category-quick-filter]').forEach((button) => {
        const count = records.filter((record) => categoryMatch(record, button.dataset.categoryQuickFilter)).length;
        const node = button.querySelector('[data-category-count]');
        if (node) node.textContent = count;
      });
      const priceLabels = {'under-100':'Unter 100 €','100-500':'100–500 €','500-1000':'500–1.000 €','over-1000':'Ab 1.000 €'};
      const matches = (record) => (!state.search || normalize(record.dataset.search).includes(normalize(state.search))) && (state.status === 'all' || (state.status === 'available' ? record.dataset.available === 'true' : record.dataset.sale === 'true')) && priceMatch(Number(record.dataset.price)) && categoryMatch(record) && (state.vendor === 'all' || record.dataset.vendor === state.vendor) && (state.productType === 'all' || record.dataset.productType === state.productType);
      const renderActive = () => {
        const active=[];
        if(state.search) active.push(['search',`Suche: ${state.search}`]);
        if(state.status !== 'all') active.push(['status',state.status === 'available' ? 'Verfügbar' : 'Angebote']);
        if(state.price !== 'all') active.push(['price',priceLabels[state.price] || state.price]);
        if(state.category !== 'all') {
          const categoryButton = root.querySelector(`[data-category-quick-filter="${CSS.escape(state.category)}"]`);
          active.push(['category',categoryButton?.dataset.categoryLabel || 'Kategorie']);
        }
        if(state.vendor !== 'all') active.push(['vendor',`Marke: ${state.vendor}`]);
        if(state.productType !== 'all') active.push(['productType',`Typ: ${state.productType}`]);
        activeRow.replaceChildren();
        active.forEach(([key,label]) => {const button=document.createElement('button');button.type='button';button.dataset.clearKey=key;button.textContent=`${label} ×`;activeRow.append(button);});
        activeRow.hidden=active.length===0;
      };
      const syncButtons = () => {
        const setPressed = (button, selected) => {
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', String(selected));
          button.removeAttribute('aria-selected');
        };
        const noTextOrFacetCriteria = !state.search && state.vendor === 'all' && state.productType === 'all';
        root.querySelectorAll('[data-filter-key="status"]').forEach((button) => setPressed(button, state.status === button.dataset.filterValue));
        root.querySelectorAll('[data-filter-key="price"]').forEach((button) => setPressed(button, state.price === button.dataset.filterValue));
        root.querySelectorAll('[data-quick-filter]').forEach((button) => setPressed(button,
          noTextOrFacetCriteria && state.price === 'all' && state.category === 'all' && state.status === button.dataset.quickFilter
        ));
        root.querySelectorAll('[data-price-quick-filter]').forEach((button) => setPressed(button,
          noTextOrFacetCriteria && state.status === 'all' && state.category === 'all' && state.price === button.dataset.priceQuickFilter
        ));
        root.querySelectorAll('[data-category-quick-filter]').forEach((button) => setPressed(button,
          noTextOrFacetCriteria && state.status === 'all' && state.price === 'all' && state.category === button.dataset.categoryQuickFilter
        ));
      };
      const hasActiveCatalogCriteria = () => Boolean(state.search)
        || state.status !== 'all'
        || state.price !== 'all'
        || state.category !== 'all'
        || state.vendor !== 'all'
        || state.productType !== 'all';
      const apply = () => {
        const hasCriteria=hasActiveCatalogCriteria();
        const filtered=records.filter(matches);
        const visibleRecords=(catalogReady || catalogFailure) ? filtered : filtered.slice(0,state.visible);
        const visibleCards=visibleRecords.map(ensureCard).filter(Boolean);
        const detachedCards=document.createDocumentFragment();
        records.forEach((record) => {
          const card=record.card;
          if(!card)return;
          card.hidden=true;
          if(card.parentNode===grid) detachedCards.append(card);
        });
        const nextCards=document.createDocumentFragment();
        visibleCards.forEach((card) => {card.hidden=false;nextCards.append(card);observeSecondaryMedia(card);});
        grid.append(nextCards);
        const incompleteResult=hasCriteria && !catalogReady;
        const resultTotal=!catalogReady && !hasCriteria ? totalProducts : filtered.length;
        const resultLabel=catalogFailure && !catalogReady
          ? (hasCriteria ? `mind. ${filtered.length}` : `${records.length} / ${totalProducts}`)
          : resultTotal;
        root.querySelectorAll('[data-filter-count],[data-result-count]').forEach((node) => {
          node.textContent=resultLabel;
        });
        root.querySelector('[data-empty]').hidden=incompleteResult || filtered.length!==0;
        if(nativePagination)nativePagination.hidden=catalogReady;
        loadMore.hidden=true;
        root.querySelector('[data-load-remaining]').textContent='';
        renderActive();
        syncButtons();
      };
      const applyAfterCatalog = () => ensureFullCatalog().then((ready) => {
        apply();
        return ready;
      });
      let loadMorePromise=null;
      const loadMoreProducts = () => {
        if(loadMorePromise)return loadMorePromise;
        const button=loadMore.querySelector('button');
        loadMore.setAttribute('aria-busy','true');
        if(button)button.disabled=true;
        loadMorePromise=(async()=>{
          const batch=Number(root.dataset.initialProducts || 12);
          const hasCriteria=hasActiveCatalogCriteria();
          if(hasCriteria){
            const ready=await ensureFullCatalog();
            if(!ready){apply();return false;}
            state.visible=Math.min(state.visible+batch,records.filter(matches).length);
            apply();
            return true;
          }
          let localMatches=records.filter(matches);
          if(state.visible>=localMatches.length && !catalogReady){
            if(currentPage>1){apply();return true;}
            const loaded=await ensureNextCatalogPage();
            if(!loaded){apply();return false;}
            localMatches=records.filter(matches);
          }
          state.visible=Math.min(state.visible+batch,catalogReady ? totalProducts : localMatches.length);
          apply();
          return true;
        })().finally(()=>{
          loadMorePromise=null;
          loadMore.removeAttribute('aria-busy');
          if(button)button.disabled=false;
        });
        return loadMorePromise;
      };
      const reset = () => {Object.assign(state,{search:'',status:'all',price:'all',category:'all',vendor:'all',productType:'all',visible:Number(root.dataset.initialProducts || 12)});search.value='';vendorSelect.value='all';typeSelect.value='all';syncButtons();apply();};
      const searchForm = search.closest('form');
      if (searchForm) searchForm.addEventListener('submit',(event) => {
        event.preventDefault();
        event.stopPropagation();
        state.search=search.value.trim();
        state.visible=Number(root.dataset.initialProducts || 12);
        applyAfterCatalog();
      });
      const searchClear = root.querySelector('[data-search-clear]');
      const openFilters=() => {filters.classList.add('is-open');backdrop.hidden=false;document.documentElement.style.overflow='hidden';if(!catalogReady)applyAfterCatalog();};
      const closeFilters=() => {filters.classList.remove('is-open');backdrop.hidden=true;document.documentElement.style.overflow='';};
      const primeCatalogFromFilters=() => {if(!catalogReady)applyAfterCatalog();};
      filters.addEventListener('pointerenter',primeCatalogFromFilters,{once:true});
      filters.addEventListener('focusin',primeCatalogFromFilters,{once:true});
      const sortUrl = root.querySelector('[data-sort-url]');
      const shippingDialog=root.querySelector('[data-shipping-dialog]');
      let shippingOpener=null;
      let searchTimer=0;
      let activeMaterialDialog=null;
      const materialThumbs=(dialog)=>Array.from(dialog?.querySelectorAll('[data-material-thumb]') || []);
      const materialIndex=(dialog)=>{
        const index=Number.parseInt(dialog?.dataset.materialIndex || '0',10);
        return Number.isFinite(index) ? index : 0;
      };
      const setMaterialImage=(dialog,requestedIndex,{focusThumb=false,scrollThumb=true}={})=>{
        if(!dialog)return false;
        const thumbs=materialThumbs(dialog);
        if(!thumbs.length){
          dialog.querySelectorAll('[data-material-prev],[data-material-next]').forEach((button)=>{
            button.disabled=true;
            button.setAttribute('aria-disabled','true');
          });
          return false;
        }
        const index=((Number(requestedIndex)%thumbs.length)+thumbs.length)%thumbs.length;
        const thumb=thumbs[index];
        const image=dialog.querySelector('.mp-uc-material-image') || dialog.querySelector('.mp-uc-material-main img');
        const nextSource=thumb.dataset.src;
        if(image && nextSource){
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src=nextSource;
          image.alt=thumb.dataset.alt || '';
          image.dataset.materialIndex=String(index);
        }
        dialog.dataset.materialIndex=String(index);
        thumbs.forEach((candidate,candidateIndex)=>{
          const selected=candidateIndex===index;
          candidate.classList.toggle('is-active',selected);
          candidate.setAttribute('aria-selected',String(selected));
          candidate.tabIndex=selected ? 0 : -1;
        });
        const counter=dialog.querySelector('[data-material-counter]') || dialog.querySelector('.mp-uc-material-main > span');
        if(counter)counter.textContent=`${index+1} / ${thumbs.length}`;
        dialog.querySelectorAll('[data-material-prev],[data-material-next]').forEach((button)=>{
          button.disabled=thumbs.length<2;
          button.setAttribute('aria-disabled',String(thumbs.length<2));
        });
        if(scrollThumb)thumb.scrollIntoView({block:'nearest',inline:'nearest'});
        if(focusThumb)thumb.focus({preventScroll:true});
        return true;
      };
      const stepMaterialImage=(dialog,step,options)=>setMaterialImage(dialog,materialIndex(dialog)+step,options);
      const initializeMaterialDialog=(dialog)=>{
        const thumbs=materialThumbs(dialog);
        thumbs.forEach((thumb,index)=>{if(!thumb.dataset.materialIndex)thumb.dataset.materialIndex=String(index);});
        const initiallyActive=Math.max(0,thumbs.findIndex((thumb)=>thumb.classList.contains('is-active')));
        setMaterialImage(dialog,initiallyActive,{scrollThumb:false});
        const stage=dialog.querySelector('[data-material-stage]');
        if(!stage)return;
        let swipe=null;
        stage.addEventListener('pointerdown',(event)=>{
          if(event.pointerType==='mouse')return;
          swipe={id:event.pointerId,x:event.clientX,y:event.clientY};
        });
        stage.addEventListener('pointerup',(event)=>{
          if(!swipe || swipe.id!==event.pointerId)return;
          const deltaX=event.clientX-swipe.x;
          const deltaY=event.clientY-swipe.y;
          swipe=null;
          if(Math.abs(deltaX)<48 || Math.abs(deltaX)<=Math.abs(deltaY))return;
          stepMaterialImage(dialog,deltaX<0 ? 1 : -1);
        });
        stage.addEventListener('pointercancel',()=>{swipe=null;});
      };
      const openMaterialDialog=(button) => {
        if(activeMaterialDialog?.isConnected && activeMaterialDialog.open){
          activeMaterialDialog.querySelector('[data-dialog-close]')?.focus();
          return;
        }
        activeMaterialDialog?.remove();
        activeMaterialDialog=null;
        const dialogId=button.dataset.materialOpen;
        const template=root.querySelector(`template[data-material-template="${CSS.escape(dialogId)}"]`);
        let source=template?.content.querySelector('dialog');
        if(!source && deferredMaterialHtml.has(dialogId)){
          const holder=document.createElement('template');
          holder.innerHTML=deferredMaterialHtml.get(dialogId);
          source=holder.content.querySelector('dialog');
        }
        if(!source)return;
        const dialog=source.cloneNode(true);
        dialog.dataset.dynamicMaterial='true';
        dialog.dataset.materialTemplateId=dialogId;
        activeMaterialDialog=dialog;
        root.append(dialog);
        dialog.scrollTop=0;
        const copy=dialog.querySelector('.mp-uc-material-copy');
        if(copy)copy.scrollTop=0;
        initializeMaterialDialog(dialog);
        dialog.addEventListener('close',() => {
          if(activeMaterialDialog===dialog)activeMaterialDialog=null;
          dialog.remove();
          if(button.isConnected)button.focus();
        },{once:true});
        try{dialog.showModal();}
        catch(error){
          if(activeMaterialDialog===dialog)activeMaterialDialog=null;
          dialog.remove();
          console.error('[Mini Power Katalog] Materialansicht konnte nicht geöffnet werden.',error);
        }
      };
      const openShippingDialog=(button) => {
        if(!shippingDialog)return;
        const card=button.closest('[data-card]');
        const taxNote=card?.querySelector('[data-card-price-note]')?.textContent?.trim();
        const deliveryNote=card?.querySelector('[data-card-delivery-text]')?.textContent?.trim();
        const taxSelector=document.querySelector('#mp-tax-selector');
        const countryLabel=document.querySelector('#mp-tax-country option:checked')?.textContent?.trim();
        const role=taxSelector?.querySelector('[data-mp-tax-role][aria-pressed="true"]')?.dataset.mpTaxRole;
        const roleLabel=role==='business'?'Geschäftskunde':role==='private'?'Privatkunde':'';
        shippingDialog.querySelector('[data-shipping-context]').textContent=['Aktuelle Auswahl',countryLabel,roleLabel].filter(Boolean).join(' · ');
        shippingDialog.querySelector('[data-shipping-tax-note]').textContent=taxNote||'Preis gemäß aktueller Shop-Einstellung';
        shippingDialog.querySelector('[data-shipping-delivery-note]').textContent=deliveryNote||'Lieferzeit: auf der Produktseite prüfen';
        shippingDialog.scrollTop=0;
        shippingOpener=button;
        shippingDialog.showModal();
      };
      root.addEventListener('keydown',(event)=>{
        const dialog=event.target.closest?.('.mp-uc-material-dialog');
        const gallery=event.target.closest?.('.mp-uc-material-gallery');
        if(!dialog || !gallery || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();
        const thumbs=materialThumbs(dialog);
        const index=event.key==='Home' ? 0 : event.key==='End' ? thumbs.length-1 : materialIndex(dialog)+(event.key==='ArrowRight' ? 1 : -1);
        setMaterialImage(dialog,index,{focusThumb:Boolean(event.target.closest?.('[data-material-thumb]'))});
      });
      root.addEventListener('input',(event) => {
        if(event.target!==search)return;
        window.clearTimeout(searchTimer);
        searchTimer=window.setTimeout(() => {
          state.search=search.value.trim();
          state.visible=Number(root.dataset.initialProducts || 12);
          applyAfterCatalog();
        },180);
      });
      root.addEventListener('change',(event) => {
        if(event.target===vendorSelect)state.vendor=vendorSelect.value;
        else if(event.target===typeSelect)state.productType=typeSelect.value;
        else if(event.target===sortUrl){
          const url=new URL(window.location.href);
          url.searchParams.set('sort_by',sortUrl.value);
          url.searchParams.set('view',root.dataset.view);
          window.location.assign(url.toString());
          return;
        }else return;
        applyAfterCatalog();
      });
      root.addEventListener('click',async (event) => {
        const target=event.target;
        const panelButton=target.closest('[data-panel-value]');
        if(panelButton){
          const card=panelButton.closest('[data-card]');
          const panel=card?._mpPanelSelector;
          if(panel){
            const variant=panel.selectVariant(panelButton.dataset.panelValue);
            const requestId=Number(card._mpTaxVariantRequestId || 0) + 1;
            card._mpTaxVariantRequestId=requestId;
            if(!variant || String(card.dataset.mpTaxVariantId || '')===String(variant.id)){
              card.removeAttribute('aria-busy');
              return;
            }
            card.setAttribute('aria-busy','true');
            const taxReady=await ensureTaxVariant(card,variant);
            if(card._mpTaxVariantRequestId!==requestId)return;
            card.removeAttribute('aria-busy');
            if(!taxReady)return;
            panel.renderVariant(variant);
            apply();
          }
          return;
        }
        const filterButton=target.closest('[data-filter-key]');
        if(filterButton){
          state[filterButton.dataset.filterKey]=filterButton.dataset.filterValue;
          state.visible=Number(root.dataset.initialProducts || 12);
          syncButtons();
          applyAfterCatalog();
          return;
        }
        const quickButton=target.closest('[data-quick-filter]');
        if(quickButton){
          state.status=quickButton.dataset.quickFilter;
          state.price='all';
          state.category='all';
          state.visible=Number(root.dataset.initialProducts || 12);
          syncButtons();
          applyAfterCatalog();
          root.querySelector('#mp-universal-products').scrollIntoView({behavior:'smooth',block:'start'});
          return;
        }
        const priceButton=target.closest('[data-price-quick-filter]');
        if(priceButton){
          state.status='all';
          state.price=priceButton.dataset.priceQuickFilter;
          state.visible=Number(root.dataset.initialProducts || 12);
          syncButtons();
          applyAfterCatalog();
          root.querySelector('#mp-universal-products').scrollIntoView({behavior:'smooth',block:'start'});
          return;
        }
        const categoryButton=target.closest('[data-category-quick-filter]');
        if(categoryButton){
          state.status='all';
          state.price='all';
          state.category=categoryButton.dataset.categoryQuickFilter;
          state.visible=Number(root.dataset.initialProducts || 12);
          syncButtons();
          applyAfterCatalog();
          root.querySelector('#mp-universal-products').scrollIntoView({behavior:'smooth',block:'start'});
          return;
        }
        const clearButton=target.closest('[data-clear-key]');
        if(clearButton){
          const key=clearButton.dataset.clearKey;
          if(key==='search'){state.search='';search.value='';}
          else{
            state[key]='all';
            if(key==='vendor')vendorSelect.value='all';
            if(key==='productType')typeSelect.value='all';
          }
          syncButtons();
          applyAfterCatalog();
          return;
        }
        if(searchClear && target.closest('[data-search-clear]')){
          window.clearTimeout(searchTimer);
          state.search='';
          search.value='';
          applyAfterCatalog();
          search.focus();
          return;
        }
        if(target.closest('[data-reset]')){reset();return;}
        if(target.closest('[data-scroll-products]')){
          root.querySelector('#mp-universal-products').scrollIntoView({behavior:'smooth',block:'start'});
          return;
        }
        if(target.closest('[data-load-more] button')){
          loadMoreProducts();
          return;
        }
        if(target.closest('[data-filter-open]')){openFilters();return;}
        if(target.closest('[data-filter-close]') || target.closest('[data-filter-backdrop]')){closeFilters();return;}
        const materialButton=target.closest('[data-material-open]');
        if(materialButton){openMaterialDialog(materialButton);return;}
        const shippingButton=target.closest('[data-shipping-payment-open]');
        if(shippingButton){openShippingDialog(shippingButton);return;}
        const closeButton=target.closest('[data-dialog-close]');
        if(closeButton){closeButton.closest('dialog')?.close();return;}
        const materialStepButton=target.closest('[data-material-prev],[data-material-next]');
        if(materialStepButton){
          const dialog=materialStepButton.closest('.mp-uc-material-dialog');
          stepMaterialImage(dialog,materialStepButton.matches('[data-material-next]') ? 1 : -1);
          return;
        }
        const thumbButton=target.closest('[data-material-thumb]');
        if(thumbButton){
          const dialog=thumbButton.closest('.mp-uc-material-dialog');
          const index=Number.parseInt(thumbButton.dataset.materialIndex || '',10);
          setMaterialImage(dialog,Number.isFinite(index) ? index : materialThumbs(dialog).indexOf(thumbButton));
          return;
        }
        if(target.matches('dialog'))target.close();
      });
      shippingDialog?.addEventListener('close',() => {shippingOpener?.focus();shippingOpener=null;});
      const tray=root.querySelector('[data-compare-tray]');
      const compareItems=root.querySelector('[data-compare-items]');
      const compareOpen=root.querySelector('[data-compare-open]');
      const compareDialog=root.querySelector('[data-compare-dialog]');
      const compareNotice=root.querySelector('[data-compare-notice]');
      const renderCompare=() => {compareItems.replaceChildren();state.selected.forEach((handle) => {const record=recordByHandle.get(handle);if(!record)return;const button=document.createElement('button');button.type='button';button.dataset.removeCompare=handle;const span=document.createElement('span');span.textContent=record.dataset.title;const close=document.createElement('i');close.textContent='×';button.append(span,close);compareItems.append(button);});root.querySelector('[data-compare-count]').textContent=state.selected.length;tray.hidden=state.selected.length===0;compareOpen.disabled=state.selected.length<2;records.forEach((record) => {const button=record.card?.querySelector('[data-compare]');if(!button)return;const selected=state.selected.includes(record.dataset.handle);button.classList.toggle('is-selected',selected);button.textContent=selected?'✓ Ausgewählt':'+ Vergleichen';});};
      root.addEventListener('click',(event) => {const button=event.target.closest('[data-compare]');if(!button)return;const card=button.closest('[data-card]');const handle=card.dataset.handle;if(state.selected.includes(handle))state.selected=state.selected.filter((value) => value!==handle);else if(state.selected.length>=3){compareNotice.hidden=false;compareNotice.textContent='Maximal drei Produkte gleichzeitig vergleichen.';return;}else state.selected.push(handle);compareNotice.hidden=true;renderCompare();});
      compareItems.addEventListener('click',(event) => {const button=event.target.closest('[data-remove-compare]');if(!button)return;state.selected=state.selected.filter((value) => value!==button.dataset.removeCompare);renderCompare();});
      compareOpen.addEventListener('click',() => {const table=root.querySelector('[data-compare-table]');table.replaceChildren();const selectedRecords=state.selected.map((handle) => recordByHandle.get(handle)).filter(Boolean);const columns=`150px repeat(${selectedRecords.length},minmax(180px,1fr))`;const rows=[['Produkt','title'],['Marke','vendor'],['Produkttyp','productType'],['Varianten','variants'],['Startpreis','price'],['Status','available']];rows.forEach(([label,key]) => {const row=document.createElement('div');row.className='mp-uc-compare-row';row.style.gridTemplateColumns=columns;const heading=document.createElement('strong');heading.textContent=label;row.append(heading);selectedRecords.forEach((record) => {const cell=key==='title'?document.createElement('a'):document.createElement('span');if(key==='title')cell.href=record.dataset.url;cell.textContent=key==='price'?new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(Number(record.dataset.price)/100):key==='available'?(record.dataset.available==='true'?'Verfügbar':'Ausverkauft'):record.dataset[key];row.append(cell);});table.append(row);});compareDialog.showModal();});
      if(catalogReady){
        try{finalizeCatalog();}catch(error){showCatalogFailure(error);}
      }else if(!paginationShapeValid){
        showCatalogFailure(new Error(`Gesamtkatalog: Seiteneinteilung ${totalPages}/${expectedTotalPages} oder Startseite ist unvollständig`));
      }else{
        root.dataset.catalogReady='false';
      }
      syncButtons();
      apply();
      const hydrateCatalog = () => {
        root._mpCatalogIdleId = null;
        root._mpCatalogTimerId = null;
        if (!root.isConnected || catalogReady || catalogFailure) return;
        ensureFullCatalog().then(() => {
          if (root.isConnected) apply();
        });
      };
      if (!catalogReady && !catalogFailure) {
        setCatalogScope('Produkte werden', 'geladen');
        if ('requestIdleCallback' in window) {
          root._mpCatalogIdleId = window.requestIdleCallback(hydrateCatalog, { timeout: 800 });
        } else {
          root._mpCatalogTimerId = window.setTimeout(hydrateCatalog, 200);
        }
      }
    };
    const cleanup = (root) => {
      root._mpTaxNoteObserver?.disconnect();
      root._mpSecondaryMediaObserver?.disconnect();
      if (root._mpSecondaryScrollScan) window.removeEventListener('scroll', root._mpSecondaryScrollScan);
      if (root._mpSecondaryIntent) {
        root.removeEventListener('pointerover', root._mpSecondaryIntent);
        root.removeEventListener('pointerdown', root._mpSecondaryIntent);
        root.removeEventListener('focusin', root._mpSecondaryIntent);
      }
      if (root._mpSecondaryEnable) {
        root.removeEventListener('wheel', root._mpSecondaryEnable);
        root.removeEventListener('touchmove', root._mpSecondaryEnable);
      }
      if (root._mpSecondaryKey) root.removeEventListener('keydown', root._mpSecondaryKey);
      if (root._mpHeroMedia && root._mpHeroSync) root._mpHeroMedia.removeEventListener('change', root._mpHeroSync);
      if (root._mpCatalogIdleId != null && 'cancelIdleCallback' in window) window.cancelIdleCallback(root._mpCatalogIdleId);
      if (root._mpCatalogTimerId != null) window.clearTimeout(root._mpCatalogTimerId);
      root._mpCatalogAbortControllers?.forEach((controller) => controller.abort());
      root._mpTaxNoteObserver = null;
      root._mpSecondaryMediaObserver = null;
      root._mpSecondaryScrollScan = null;
      root._mpSecondaryIntent = null;
      root._mpSecondaryEnable = null;
      root._mpSecondaryKey = null;
      root._mpHeroMedia = null;
      root._mpHeroSync = null;
      root._mpCatalogAbortControllers = null;
    };
    document.querySelectorAll('[data-mp-universal-collection]').forEach(init);
    document.addEventListener('shopify:section:load',(event) => event.target.querySelectorAll('[data-mp-universal-collection]').forEach(init));
    document.addEventListener('shopify:section:unload',(event) => event.target.querySelectorAll('[data-mp-universal-collection]').forEach(cleanup));
  })();
